import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export function withRouter(WrappedComponent) {
    return function WithRouter(props) {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();

        const history = {
            push: (to, state) => navigate(to, { state }),
            replace: (to, state) => navigate(to, { replace: true, state }),
            goBack: () => navigate(-1),
        };

        return (
            <WrappedComponent
                {...props}
                location={location}
                navigate={navigate}
                params={params}
                history={history}
            />
        );
    };
}
